module.exports = {
      id: "cdccde686e8f4e4188ba3255bae1ae8bstate-new.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.svg#cdccde686e8f4e4188ba3255bae1ae8bstate-new.svg",
      toString: function () {
        return this.url;
      }
    }